import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'c3e00c90-1edd-48bb-801a-ec5b73ecaf74',
    countryCodes: ['GB'],
    locale: 'en-GB',
});
